import { BuyerLegalType } from "../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../auth/useLoggedInWithOrgContextState";

/**
 * Whether the current organization procures under the public procurement rules.
 *
 * This is a property of the organization, not of its subscription: it decides the vocabulary the
 * UI speaks and which regime a draft classifies into, so letting a billing flag answer it meant an
 * access change silently renamed the domain. A null legal type is a public buyer that has not
 * filled in its BT-11 code yet — new organizations are created PRIVATE.
 */
export const useRunsPublicProcurements = (): boolean =>
  useLoggedInWithOrgContextState().selectedOrg.buyerLegalType !== BuyerLegalType.Private;
